import { defineMessages } from 'react-intl';

export default defineMessages({
  bannerMainText: {
    defaultMessage:
      'Based on the past 30 days, you could have saved up to {savingsAmount}. Learn more about how you could save in the future.',
    id: 'WkfNXc',
    description: 'Banner text for automation recommendation explaining to the user how much they can save.',
  },
  exploreSavings: {
    defaultMessage: 'Explore Savings',
    id: 'YZgNtL',
    description: 'Call to Action for getting the user to open the Automation Recommendation modal',
  },
  disabledButtonMessage: {
    defaultMessage: 'Your request has been submitted. An expert will reach out within the next business day to schedule a call.',
    id: 'gWC98N',
    description: 'Message that shows when CTA is disabled for contacting sales to set up automation rules',
  },
});
